module.exports = __webpack_public_path__ + "img/Icon_Crear_PEI.c77d38dd.svg";